import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { setupInterceptors } from "api/config";

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
});

setupInterceptors(store);

export default store;
